import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NewHomePage from './pages/NewHomePage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<NewHomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
